import React, { createRef } from "react";
import styled from "styled-components";
import GoodCartNew from "./SmallComps/GoodCartNew";
import Arrow from "../../assets/SMSVG/SellerSvg/arrow";
import GoodCartWithSelectorVertical from "./SmallComps/GoodCartWithSelectorVertical";

const StyleLaptop = styled.div`
    .main-pad{
        grid-column: span 1;
    }
    .main-box{
        grid-column-start: 2;
        grid-column: span 3;
        display: flex;
        flex-direction: column;
        flex-grow: 1;
        height: auto;
        height: 100%;
    }
    .container-scroll {
        grid-column: 1/13;
        width: 100%;
        overflow-x: scroll;
        padding: 0.5rem 0;
        ::-webkit-scrollbar {
            -ms-overflow-style: none;  /* Internet Explorer 10+ */
            scrollbar-width: none;  /* Firefox */
            display: none;  /* Safari and Chrome */
        }
    } 
    .main-scroll{
        display: flex;
        flex-direction: row;
        width: 100%;
        justify-content: space-between;
        position: relative;
        -ms-overflow-style: none; 
        scrollbar-width: none; 
        ::-webkit-scrollbar {
            -ms-overflow-style: none;  /* Internet Explorer 10+ */
            scrollbar-width: none;  /* Firefox */
            display: none;  /* Safari and Chrome */
        }
        .main-box{
            width: calc(100% - 1rem);
            margin: 0 0.5rem;
            display: flex;
            flex-direction: column;
            flex-grow: 1;
            height: auto;
            height: 100%;
        }
    }
    .arrow{
        position: absolute;
        display: flex;
        align-items: center;
        border: 1px solid var(--n-grey-2);
        padding: 1.5rem 1rem;
        box-shadow: 0px 4px 30px -4px rgba(0, 0, 0, 0.12);
        border-radius: 4px;
        background-color: var(--body-2);
        height: 5rem;
        z-index: 2;
        .arr{
            width: 1rem;
        }
    }
    .right{
        right: -1.5rem;
        top: 25%;
    }
    .left{
        left: -1.5rem;
        top: 25%;
        .arr{
            transform: rotate(-180deg);
        }
    }
`
const StyleMobile = styled.div`
    display: flex;
    flex-direction: row;
    overflow: hidden;
    justify-content: center;
    padding:0;
    width: 100%;   
    .container-scroll {
        width: 100%;
        overflow-x: scroll;
        ::-webkit-scrollbar {
            -ms-overflow-style: none;  /* Internet Explorer 10+ */
            scrollbar-width: none;  /* Firefox */
            display: none;  /* Safari and Chrome */
        }
    } 
    .main-scroll{
        display: flex;
        flex-direction: row;
        width: 100%;
        justify-content: space-between;
        position: relative;
        -ms-overflow-style: none; 
        scrollbar-width: none; 
        ::-webkit-scrollbar {
            -ms-overflow-style: none;  /* Internet Explorer 10+ */
            scrollbar-width: none;  /* Firefox */
            display: none;  /* Safari and Chrome */
        }
        .main-box{
            width: calc(100% - 1rem);
            margin: 0 0.5rem;
            display: flex;
            flex-direction: column;
            flex-grow: 1;
        }
    }
    .arrow{
        cursor: pointer;
        position: absolute;
        display: flex;
        align-items: center;
        border: 1px solid var(--n-grey-2);
        padding: 0.75rem 0.75rem;
        box-shadow: 0px 4px 30px -4px rgba(0, 0, 0, 0.12);
        border-radius: 4px;
        background-color: var(--body-2);
        height: 4rem;
        z-index: 2;
        .arr{
            width: 1rem;
        }
    }
    .right{
        right: 0;
        top: 30%;
    }
    .left{
        left: 0;
        top: 30%;
        .arr{
            transform: rotate(-180deg);
        }
    }
`

class RibbonSuggetGoodSelector extends React.Component{
    constructor(props) {
        super(props);
        this.refScroll = createRef()
    }
    rightClick=()=>{
        let scrol = this.refScroll.current.scrollLeft + (window.innerWidth * 0.80)
        if(window.innerWidth < 850){
            scrol = this.refScroll.current.scrollLeft + (window.innerWidth * 0.60)
        }
        this.refScroll.current.scrollTo({
            left: scrol,
            behavior: "smooth"
        })
    }
    leftClick=()=>{
        let scrol = this.refScroll.current.scrollLeft - (window.innerWidth * 0.80)
        if(window.innerWidth < 850){
            scrol = this.refScroll.current.scrollLeft - (window.innerWidth * 0.60)
        }
        this.refScroll.current.scrollTo({
            left: scrol,
            behavior: "smooth"
        })
    }
    laptopRender(){
        let classname = 'main-grid'
        let pad = <div className="main-pad"></div>
        if(this.props.noPad){
            classname = "main-grid-inner"
            pad = ""
        }
        if(this.props.goods.length > 4) {
            return(
                <StyleLaptop className={classname} >
                    {pad}
                    <div className="arrow right" onClick={this.rightClick}><Arrow/></div>
                    <div className="container-scroll" ref={this.refScroll}>
                        <div className="main-scroll" style={{width: (this.props.goods.length*25) + "%"}}>
                            {this.makeGoods()}
                        </div>
                    </div>
                    <div className="arrow left" onClick={this.leftClick}><Arrow/></div>
                    {pad}
                </StyleLaptop>
            )  
        }
        return(
            <StyleLaptop className={classname} >
                {pad}
                {this.makeGoods()}
                {pad}
            </StyleLaptop>
        )
    }
    makeGoods = () => {
        return this.props.goods.map((v, i) => {
            return (
                <div className="main-box" key={i}>
                    <GoodCartWithSelectorVertical data={v}/>
                </div>
            )
        })
    }
    mobileRender(){
        return(
            <StyleMobile>
                <div className="arrow right" onClick={this.rightClick}><Arrow/></div>
                <div className="container-scroll" ref={this.refScroll}>
                    <div className="main-scroll" style={{width: (this.props.goods.length*60) + "vw"}}>
                        {this.makeGoods()}
                    </div>
                </div>
                <div className="arrow left" onClick={this.leftClick}><Arrow/></div>
            </StyleMobile>
        )
    }

    render(){
        if(window.innerWidth < 850 ){
            return this.mobileRender()
        }else{
            return this.laptopRender()
        }
    }
}
export default RibbonSuggetGoodSelector;